import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ToastController } from 'ionic-angular';
import { AngularFireDatabase } from "angularfire2/database";
import { Device } from '@ionic-native/device';
/**
 * Generated class for the WaiterOrderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-waiter-order',
  templateUrl: 'waiter-order.html',
})
export class WaiterOrderPage {
  order: any;
  user: any;
  userObj: any;
 server: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, 
  public af: AngularFireDatabase,public device:Device,public toastCtrl:ToastController) {
    this.order = this.navParams.get('order');
    this.user = JSON.parse(localStorage.getItem('UserId'));
    this.userObj = JSON.parse(localStorage.getItem('UserObj'));
    this.server = JSON.parse(localStorage.getItem('server'));

  }

  Update(message) {
     let customerId:any=this.order.customerId || ''
     let sender = this.user ? this.user.uid : this.device.uuid;
    let waiterCountPath = 'waiterordercount/' + this.user.uid + '/' + this.order.itemType;
    let isModified = false;
    let messagePath = 'Orders/' + this.userObj.waiterTo + '/' + this.order.key + '/waiterMessage';
    this.af.object(messagePath).set(message);
    this.af.object(waiterCountPath).valueChanges().subscribe(res => {
      console.log(isModified);
      let count = (res == null || res == undefined) ? 0 : res as number;
      count = count - 1;
      if (!isModified) {
        isModified = true;
        this.af.object(waiterCountPath).set(count);
      }
    });
    this.af.database.ref('notifications/').push({ message: message, receiver:customerId , sender: this.order.waiterId })
      .then(res => {
        let toast = this.toastCtrl.create({
          message: 'Notified to Customer',
          duration: 2000,
          position: 'bottom'
        });
        toast.present();
      });
    this.navCtrl.pop();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad WaiterOrderPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/waiter-order/waiter-order.ts